
// Akademisyen odaları
const akademisyenler = {
  arsOda1: {
    type: "akademisyen",
    title: "Akademisyen Odası",
    members: [
      {
        name: "Arş. Gör. Seda Efendioğlu",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/7819" alt="Seda Efendioğlu"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Ünvanı:</strong> Araştırma Görevlisi</p> <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Bilgisayar Öğrenimi, Doğal Dil İşlemesi, Metin/Doküman İşleme, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> sedatokmak@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/sedatokmak" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
      {
        name: "Arş. Gör. Büşra Özkellekci",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/100169" alt="Büşra Özkellekci"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Ünvanı:</strong> Araştırma Görevlisi</p>
          <p><strong>Araştırma Alanları:</strong> Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Yazılım</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> busraozkellekci@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/busraozkellekci" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },

      {
        name: "Arş. Gör. Muhammed Kılıç",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/5219765" alt="Muhammed Kılıç"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Ünvanı:</strong> Araştırma Görevlisi</p> 
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Bilgi Güvenliği ve Güvenilirliği, Bilgisayarla Görme, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> muhammedkilic@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/muhammedkilic" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },

      {
        name: "Arş. Gör. Batuhan Çimşit",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/6420031" alt="Batuhan Çimşit"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Ünvanı:</strong> Araştırma Görevlisi</p> 
          <p><strong>Araştırma Alanları:</strong> Bilgisayarla Görme, Bilgisayar Öğrenimi, Doğal Dil İşlemesi, Örüntü Tanıma ve Görüntü İşleme, Sinirsel Ağlar</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> batuhancimsit@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/batuhancimsit" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },

      {
        name: "Arş. Gör. Metehan Bulut",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/100216" alt="Metehan Bulut"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Ünvanı:</strong> Araştırma Görevlisi</p> 
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Bilgi Güvenliği ve Güvenilirliği, Bilgi Gizleme, Kriptoloji, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> metehanbulut@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/metehanbulut" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
  },

  arsOda2: {
    type: "akademisyen",
    title: "Akademisyen Odası",
    members: [
      {
        name: "Arş. Gör. Orhan Sivaz",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/15541" alt="Orhan Sivaz"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Ünvanı:</strong> Araştırma Görevlisi</p> 
          <p><strong>Araştırma Alanları:</strong> Algoritmalar, Bilgisayarla Görme, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> osivaz@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/osivaz" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
      {
        name: "Arş. Gör. Burak Aydın",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/19573" alt="Burak Aydın"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Ünvanı:</strong> Araştırma Görevlisi</p> 
          <p><strong>Araştırma Alanları:</strong> Donanım Güvenliği, Bilgisayar Ağları, Haberleşme ve Ağ Protokolleri, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> burakaydin@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/burakaydin" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },

      {
        name: "Arş. Gör. Samet Dinçer",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/2419657" alt="Samet Dinçer"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Ünvanı:</strong> Araştırma Görevlisi</p> 
          <p><strong>Araştırma Alanları:</strong> Bilgi Güvenliği ve Güvenilirliği</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> dincer@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/dincer" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },

    ],
  },


  omerOda: {
    type: "akademisyen",
    title: "Ögr. Gör. Ömer Çakır",
    members: [
      {
        name: "Ögr. Gör. Ömer Çakır",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3863" alt="Ömer Çakır"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Bilgisayar Grafiği, Bilgisayarda Grafik, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> cakiro@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/cakiro" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
  },

  zaferOda: {
    type: "akademisyen",
    title: "Öğr. Gör. Dr. Zafer Yavuz",
    members: [
      {
        name: "Öğr. Gör. Dr. Zafer Yavuz",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3897" alt="Zafer Yavuz"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong>  Bilgisayar Bilimleri, Bilgisayarla Görme, Bilgisayarla Görme, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Örüntü Tanıma ve Görüntü İşleme, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> zaferyavuz@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/zaferyavuz" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
  },

  muratAOda: {
    type: "akademisyen",
    title: "Dr. Ögr. Üyesi Murat Aykut",
    members: [
      {
        name: "Dr. Ögr. Üyesi Murat Aykut",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3904" alt="Murat Aykut"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong>  Bilgisayar Bilimleri, Bilgisayarla Görme, Bilgisayarla Görme, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> murat_aykut@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/murat_aykut" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
  },

  seymaOda: {
    type: "akademisyen",
    title: "Dr. Ögr. Üyesi Şeyma Aymaz",
    members: [
      {
        name: "Dr. Ögr. Üyesi Şeyma Aymaz",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/7080" alt="Şeyma Aymaz"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong>Donanım ve Mimari, Genel Bilgisayar Bilimi</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> seymademir@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/seymademir" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
  },

  muratEOda: {
    type: "akademisyen",
    title: "Prof. Dr. Murat Ekinci",
    members: [
      {
        name: "Prof. Dr. Murat Ekinci",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3796" alt="Murat Ekinci"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgi Sistemleri, Haberleşme ve Kontrol Mühendisliği, Sinyal İşleme, Görüntü ve Video İşleme, Örüntü Tanıma ve Analizi, Bilgisayar Bilimleri, Bilgisayarla Görme, Bilgisayarla Görme, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Bilgisayar Öğrenimi, İnsan Bilgisayar Etkileşimi, Örüntü Tanıma ve Görüntü İşleme, Sinirsel Ağlar, Biyomedikal Mühendisliği, Biyomedikal Görüntü İşleme, Biyomedikal Görüntü İşleme, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> ekinci@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/ekinci" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },
  
  selcukOda: {
    type: "akademisyen",
    title: "Dr. Ögr. Üyesi Selçuk Cevher",
    members: [
      {
        name: "Dr. Ögr. Üyesi Selçuk Cevher",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3860" alt="Selçuk Cevher"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Haberleşme Ağları, Bilgisayar Bilimleri, Bilgisayar Ağları, Haberleşme ve Ağ Protokolleri, Veri Yönlendirme, Ağ Mimarisi, Veriyolu hatları -Arayüz haberleşme, Gerçek zamanlı yazılım</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> cevhers@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/cevhers" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  baharOda: {
    type: "akademisyen",
    title: "Dr. Ögr. Üyesi Bahar Hatipoğlu Yılmaz",
    members: [
      {
        name: "Dr. Ögr. Üyesi Bahar Hatipoğlu Yılmaz",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/8236" alt="Bahar Hatipoğlu Yılmaz"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Biyomedikal Mühendisliği, Biyosinyal İşleme, Biyosinyal İşleme, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> baharhatipoglu@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/baharhatipoglu" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  gulOda: {
    type: "akademisyen",
    title: "Dr. Ögr. Üyesi Gül Tahaoğlu",
    members: [
      {
        name: "Dr. Ögr. Üyesi Gül Tahaoğlu",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/8243" alt="Gül Tahaoğlu"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Bilgi Güvenliği ve Güvenilirliği, Bilgi Gizleme, Veritabanı ve Veri Yapıları, Bilgi Depolaması ve Geri Kazanımı, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Örüntü Tanıma ve Görüntü İşleme, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> gultahaoglu@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/gultahaoglu" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  selenOda: {
    type: "akademisyen",
    title: "Doç. Dr. Selen Ayas",
    members: [
      {
        name: "Doç. Dr. Selen Ayas",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/7045" alt="Selen Ayas"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Bilgisayarla Görme, Bilgisayarla Görme, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Örüntü Tanıma ve Görüntü İşleme, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> selenguven@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/selenguven" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  sedatOda: {
    type: "akademisyen",
    title: "Doç. Dr. Sedat Görmüş",
    members: [
      {
        name: "Doç. Dr. Sedat Görmüş",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/7686" alt="Sedat Görmüş"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Bilgisayar Ağları, Haberleşme ve Ağ Protokolleri, Elektrik-Elektronik Mühendisliği, Elektronik, Dönüştürücüler ve Algılama Aygıtları, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> sedatgormus@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/sedatgormus" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  huseyinOda: {
    type: "akademisyen",
    title: "Doç. Dr. Hüseyin Pehlivan",
    members: [
      {
        name: "Doç. Dr. Hüseyin Pehlivan",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3819" alt="Hüseyin Pehlivan"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Algoritmalar, Sayısal Algoritmalar, Kuramsal Bilgisayar Bilimleri, Biçimsel Diller, Biçimsel Yöntemler, Veritabanı ve Veri Yapıları, Veritabanı Sistemleri, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Metin/Doküman İşleme, Yazılım, İşletim Sistemleri, Programlama Dilleri, Yazılımla Hesaplama, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> pehlivan@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/pehlivan" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  besteOda: {
    type: "akademisyen",
    title: "Doç. Dr. Beste Üstibioğlu",
    members: [
      {
        name: "Doç. Dr. Beste Üstibioğlu",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/7023" alt="Beste Üstibioğlu"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Bilgi Güvenliği ve Güvenilirliği, Bilgi Sistemi Güvenilirliği, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> bustibioglu@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/bustubioglu" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  bekirOda: {
    type: "akademisyen",
    title: "Prof. Dr. Bekir Dizdaroğlu",
    members: [
      {
        name: "Prof. Dr. Bekir Dizdaroğlu",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3834" alt="Bekir Dizdaroğlu"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Sinyal İşleme, Görüntü ve Video İşleme, Bilgisayar Bilimleri, Bilgisayarla Görme, Yazılım, Programlama Dilleri, Biyomedikal Mühendisliği, Biyomedikal Görüntü İşleme, Matematik, Diferansiyel denklemler, Temel Bilimler, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> bekir@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/bekir" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  cemalOda: {
    type: "akademisyen",
    title: "Prof. Dr. Cemal Köse",
    members: [
      {
        name: "Prof. Dr. Cemal Köse",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3782" alt="Cemal Köse"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Algoritmalar, Paralel Algoritmalar, Bilgisayar Ağları, Bilgisayar Grafiği, Donanım, İşlemci Mimarisi, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Örüntü Tanıma ve Görüntü İşleme, Yazılım, İşletim Sistemleri, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> ckose@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/ckose" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  vasifOda: {
    type: "akademisyen",
    title: "Prof. Dr. Vasif Nabiyev",
    members: [
      {
        name: "Prof. Dr. Vasif Nabiyev",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/5762" alt="Vasif Nabiyev"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Algoritmalar, Bilgi Güvenliği ve Güvenilirliği, Yapay Zeka, Bilgisayarda Öğrenme ve Örüntü Tanıma, Otomatik Problem Çözümü, Kuram Kanıtlaması ve Mantıksal Nedenleme, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> vasif@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/vasif" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  guzinOda: {
    type: "akademisyen",
    title: "Prof. Dr. Güzin Ulutaş",
    members: [
      {
        name: "Prof. Dr. Güzin Ulutaş",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3876" alt="Güzin Ulutaş"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Bilgi Güvenliği ve Güvenilirliği, Bilgi Gizleme, Kriptoloji, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> gulutas@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/gulutas" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  mustafaUOda: {
    type: "akademisyen",
    title: "Prof. Dr. Mustafa Ulutaş",
    members: [
      {
        name: "Prof. Dr. Mustafa Ulutaş",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3970" alt="Mustafa Ulutaş"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong> Bilgisayar Bilimleri, Bilgi Güvenliği ve Güvenilirliği, Bilgi Sistemi Güvenilirliği, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> ulutas@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/ulutas" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  tugrulOda: {
    type: "akademisyen",
    title: "Prof. Dr. Tuğrul Çavdar",
    members: [
      {
        name: "Prof. Dr. Tuğrul Çavdar",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3822" alt="Tuğrul Çavdar"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong>  Kablosuz İletişim, Kuantum Haberleşme, Robotik ve Mekatronik Sistemler, İnsansı Robotlar, Kuantum Kriptografi, Bilgisayar Ağları, Haberleşme ve Ağ Protokolleri, Kuantum mekaniği, alan teorileri ve özel relativite</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> ulduz@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/ulduz" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },

  mustafaYOda: {
    type: "akademisyen",
    title: "Arş. Gör. Dr. Mustafa Yazıcı",
    members: [
      {
        name: "Arş. Gör. Dr. Mustafa Yazıcı",
        content: `
          <div style="text-align:center;margin-bottom:15px;">
            <img src="https://avesis.ktu.edu.tr/user/image/3923" alt="Mustafa Yazıcı"
              style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
          </div>
          <p><strong>Araştırma Alanları:</strong>  Bilgisayar Bilimleri, Bilgi Güvenliği ve Güvenilirliği, Yazılımla Hesaplama, Biyomedikal Mühendisliği, Biyosinyal İşleme, Mühendislik ve Teknoloji</p>
          <p><strong>Ofis Saatleri:</strong> Pazartesi-Cuma 09:00-17:00</p>
          <p><strong>Email:</strong> myazici@ktu.edu.tr</p>
          <div style="text-align:center;margin-top:15px;">
            <a href="https://avesis.ktu.edu.tr/myazici" target="_blank"
              style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
              Akademik Profiline Git
            </a>
          </div>
        `,
      },
      
    ],
    
  },


};

// Laboratuvarlar örnek
const laboratuvarlar = {
  // lab1: {
  //   title: "Bilgisayar Laboratuvarı - 1",
  //   content: `
  //     <p><strong>Kapasite:</strong> 30 kişi</p>
  //     <p><strong>Açık Saatler:</strong> Pazartesi-Cuma 08:00-18:00</p>
  //   `
  // },
};

// Derslikler örnek 
const derslikler = {
  derslik1: {
    type: "schedule",
    title: "D1 Dersliği",
    schedule: [
      
      { gun: "Pazartesi", saat: "09:00-12:00", ders: "Olasılık ve İstatistik", hoca: "Dr. Öğr. Üyesi Gül Tahaoğlu", sinif: 2 },
      
      { gun: "Pazartesi", saat: "13:00-16:00", ders: "Software Engineering", hoca: "Doç. Dr. Sedat Görmüş", sinif: 2 },
     
    
      { gun: "Salı", saat: "09:00-12:00", ders: "Database Management",   hoca: "Prof. Dr. Güzin Ulutaş",  sinif: 3 },
      
      { gun: "Salı", saat: "13:00-16:00", ders: "Computer Architecture",  hoca: "Dr. Ögr. Üyesi Selçuk Cevher",  sinif: 3 },
      
      
      { gun: "Çarşamba", saat: "09:00-12:00", ders: "Computer Networks",  hoca: "Prof. Dr. Cemal Köse",  sinif: 3 },
      
      { gun: "Çarşamba", saat: "13:00-16:00", ders: "Automata Theory",   hoca: "Dr. Ögr. Üyesi Selçuk Cevher",  sinif: 2 },
      
      
      { gun: "Perşembe", saat: "10:00-12:00", ders: "Engineering Mathematics", hoca: "Prof. Dr. Murat Ekinci",  sinif: 2 },
      
      { gun: "Perşembe", saat: "13:00-16:00", ders: "Optimizasyon",      hoca: "Prof. Dr. Vasif Nabiyev",  sinif: 3 },
     
      
      { gun: "Cuma", saat: "10:00-12:00", ders: "Engineering Mathematics", hoca: "Prof. Dr. Murat Ekinci",  sinif: 2 },
      
      { gun: "Cuma", saat: "13:00-16:00", ders: "Programming Languages", hoca: "Doç. Dr. Hüseyin Pehlivan",  sinif: 2 },
    
    ]
  },

  derslik2: {
    type: "schedule",
    title: "D2 Dersliği",
    schedule: [
      
      { gun: "Pazartesi", saat: "10:00-12:00", ders: "Fizik 2 - B",      hoca: "Prof. Dr. Coşkun Aydın",  sinif: 1 },
      
      { gun: "Pazartesi", saat: "13:00-15:00", ders: "Fizik 2 - A",      hoca: "Prof. Dr. Coşkun Aydın",  sinif: 1 },
      
      { gun: "Pazartesi", saat: "15:00-17:00", ders: "İş Sağlığı ve Güvenliği", hoca: "Dr. Öğr. Üyesi Şeyma Aymaz",  sinif: 1 },
      
      { gun: "Pazartesi", saat: "08:00-10:00", ders: "Bilgisayar Grafikleri", hoca: "Ögr. Gör. Ömer Çakır",  sinif: 3 },
      
      
      { gun: "Salı", saat: "13:00-16:00", ders: "Elektrik Devreleri",    hoca: "Prof. Dr. Bekir Dizdaroğlu",  sinif: 1 },
      
      { gun: "Salı", saat: "09:00-12:00", ders: "Algoritmalar",           hoca: "Prof. Dr. Vasif Nabiyev",  sinif: 2 },
      
      
      { gun: "Çarşamba", saat: "10:00-12:00", ders: "Fizik 2 - B", 
      hoca: "Prof. Dr. Coşkun Aydın",  sinif: 1 },
      
      { gun: "Çarşamba", saat: "13:00-15:00", ders: "Fizik 2 - A", 
      hoca: "Prof. Dr. Coşkun Aydın",  sinif: 1 },
      
      
      { gun: "Perşembe", saat: "08:00-10:00", ders: "Matematik 2 - B",   hoca: "Dr. Öğr. Üyesi Fatih Yılmaz",  sinif: 1 },
      
      { gun: "Perşembe", saat: "10:00-12:00", ders: "Bilişim Etiği",     hoca: "Dr. Öğr. Üyesi Bahar Hatipoğlu Yılmaz",  sinif: 1 },
      
      { gun: "Perşembe", saat: "13:00-16:00", ders: "Programming 2",     hoca: "Doç. Dr. Beste Üstübioğlu",  sinif: 1 },

      
      { gun: "Cuma", saat: "09:00-12:00", ders: "System Programming",  hoca: "Doç. Dr. Hüseyin Pehlivan",  sinif: 3 },
    
    ]
  },

  derslik8: {
    type: "schedule",
    title: "D8 Dersliği",
    schedule: [
      
      { gun: "Pazartesi", saat: "10:00-12:00", ders: "Matematik 2 - A",   hoca: "Doç. Dr. Hüsnü Anıl Çoban",  sinif: 1 },
      
      { gun: "Pazartesi", saat: "13:00-16:00", ders: "Tıbbi Görüntüleme Sistemleri", hoca: "Prof. Dr. Bekir Dizdaroğlu",  sinif: 4 },
      
      
      { gun: "Salı", saat: "13:00-16:00", ders: "Veri Madenciliği",      hoca: "Doç. Dr. Selen Ayas",  sinif: 4 },
      
      
      { gun: "Çarşamba", saat: "10:00-12:00", ders: "Matematik 2 - A",   hoca: "Doç. Dr. Hüsnü Anıl Çoban",  sinif: 1 },
      
      { gun: "Çarşamba", saat: "08:00-10:00", ders: "Matematik 2 - B",    hoca: "Dr. Öğr. Üyesi Fatih Yılmaz",  sinif: 1 },

      
      { gun: "Cuma", saat: "08:00-10:00", ders: "English 2 - A",        hoca: "Öğr. Gör. Akın Aydın",  sinif: 1 },
      
      { gun: "Cuma", saat: "10:00-12:00", ders: "English 2 - A",          hoca: "Öğr. Gör. Akın Aydın",  sinif: 1 },
    
    ]
  },

  derslik9: {
    type: "schedule",
    title: "D9 Dersliği",
    schedule: [
      
      { gun: "Pazartesi", saat: "09:00-12:00", ders: "Ağ Güvenliği",      hoca: "Prof. Dr. Güzin Ulutaş", sinif: 4 },
      
      
      { gun: "Perşembe", saat: "13:00-16:00", ders: "Görüntü İşleme", hoca: "Prof. Dr. Murat Ekinci",  sinif: 3 },
      
    ]
  },

};


// Bağımsız Öğrenci Kulüpleri
const kulupler = {
  SEC: {
    type: "kulup", // "akademisyen" veya "schedule" olmadığı için doğrudan default şablonu tetikler
    title: "SEC - KTÜ Siber Güvenlik Kulübü",
    content: `
      <div style="text-align:center;margin-bottom:15px;">
        <img src="https://ktusec.com.tr/assets/logo-1Eu7pelV.png" alt="SEC - KTÜ Siber Güvenlik Kulübü Amblemi"
          style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
      </div>
      <p><strong>Hakkında:</strong> Karadeniz Teknik Üniversitesi bünyesinde faaliyet gösteren siber güvenlik kulübüdür. Dijital güvenlik alanında bilgi ve farkındalık düzeyi yüksek, etik değerlere önem veren bir topluluk oluşturarak; sektörle öğrencileri bir araya getirmeyi, birlikte öğrenmeyi ve gelişmeyi amaçlar.</p>
      <p style="margin-top:10px;">
      <div style="text-align:center;margin-top:20px;">
        <a href="https://ktusec.com.tr" target="_blank"
          style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
          Kulüp Sayfasına Git
        </a>
      </div>
    `,
  },
  
  CEC: {
    type: "kulup",
    title: "CEC - KTÜ Bilgisayar Mühendisliği Kulübü",
    content: `
      <div style="text-align:center;margin-bottom:15px;">
        <img src="https://ugc.production.linktr.ee/UnCOeNGoSmWno04vN4Kz_I8PnMQst12wIHjw9?io=true&size=avatar-v3_0" alt="KTÜ Bilgisayar Mühendisliği Kulübü Amblemi"
          style="width:120px;height:120px;border-radius:50%;object-fit:cover;border:3px solid #1a6fbf;">
      </div>
      <p><strong>Hakkında:</strong> Bilgisayar Mühendisliği bünyesinde yazılım geliştirme, web/mobil teknolojiler üzerine çalışmalar yapan ve ayrıca sosyal etkinlikler düzenleyen öğrenci topluluğudur.</p>
      <div style="text-align:center;margin-top:20px;">
        <a href="https://www.instagram.com/ktucec" target="_blank"
          style="display:inline-block;padding:8px 15px;background:#1a6fbf;color:white;text-decoration:none;border-radius:5px;font-weight:bold;">
          Kulüp Sayfasına Git
        </a>
      </div>
    `,
  },
  // İleride başka kulüp eklemek istersen bu şekilde altına eklemeye devam edebilirsin
};

// Tüm oda verileri birleştirildi
export const roomData = {
  ...akademisyenler,
  ...laboratuvarlar,
  ...derslikler,
  ...kulupler,
};


export const roomPoints = [
  { roomId: "arsOda1", position: { x: -3.73, y: 0.4, z: -14.3 }, rotationY: Math.PI / 2 },
  { roomId: "arsOda2", position: { x: -2.85, y: 0.4, z: -13.3 }, rotationY: Math.PI / 2 },
  { roomId: "omerOda", position: { x: -4.52, y: 1.25, z: -5.2 }, rotationY: Math.PI / 2 },
  { roomId: "zaferOda", position: { x: -4.53,y: 2.1,z: -6.1 }, rotationY: Math.PI / 2 },
  { roomId: "muratAOda", position: { x: -3.03, y: 2.1, z: -7.75 }, rotationY: Math.PI / 2 },
  { roomId: "seymaOda", position: { x: -4.53, y: 1.25, z: -6.1 }, rotationY: Math.PI / 2 },
  { roomId: "muratEOda", position: { x: -3.42, y: 2.1, z: -7.26 }, rotationY: 0 }, 
  { roomId: "selcukOda", position: { x: -4.53, y: 1.25, z: -7.7 }, rotationY: Math.PI / 2 }, 
  { roomId: "baharOda", position: { x: -3.03, y: 2.1, z: -8.5 }, rotationY: Math.PI / 2 }, 
  { roomId: "gulOda", position: { x: -4.53, y: 2.1, z: -7.7 }, rotationY: Math.PI / 2 },
  { roomId: "selenOda", position: { x: -4.53, y: 2.1, z: -6.8 }, rotationY: Math.PI / 2 }, 
  { roomId: "sedatOda", position: { x: -3.45, y: 2.1, z: -4.9 }, rotationY: 0 },
  { roomId: "huseyinOda", position: { x: -4.53, y: 1.25, z: -6.8 }, rotationY: Math.PI / 2  }, 
  { roomId: "besteOda", position: { x: -3.02, y: 2.1, z: -5.2 }, rotationY: Math.PI / 2  }, 
  { roomId: "bekirOda", position: { x: -4.53, y: 2.1, z: -4.5 }, rotationY: Math.PI / 2  }, 
  { roomId: "cemalOda", position: { x: -4.53, y: 2.1, z: -5.2 }, rotationY: Math.PI / 2  }, 
  { roomId: "vasifOda", position: { x: -4.53, y: 2.1, z: -8.5}, rotationY: Math.PI / 2  }, 
  { roomId: "guzinOda", position: { x: -4.53, y: 1.27, z: -3.6}, rotationY: Math.PI / 2  }, 
  { roomId: "mustafaUOda", position: { x: -4.53, y: 1.27, z: -4.5}, rotationY: Math.PI / 2  }, 
  { roomId: "tugrulOda", position: { x: -4.53, y: 2.1, z: -3.6 }, rotationY: Math.PI / 2  },
  { roomId: "mustafaYOda", position: { x: -3.42, y: 2.1, z: -5.625 }, rotationY: 0  },
  
  { roomId: "derslik1",  position: { x: -6.08, y: 0.2, z: 3.8   }, rotationY: Math.PI / 2 },
  { roomId: "derslik2",  position: { x: -6.08, y: 0.2, z: 8.9   }, rotationY: Math.PI / 2 },
  { roomId: "derslik8",  position: { x: -3.03, y: 1.26, z: 7.9   }, rotationY: Math.PI / 2 },
  { roomId: "derslik9",  position: { x: -3.03, y: 1.26, z: 10.1   }, rotationY: Math.PI / 2 },

  { roomId: "SEC", position: { x: -4.48, y: 0.4, z: -4.6 }, rotationY: Math.PI / 2 },
  { roomId: "CEC", position: { x: -2.7, y: 0.4, z: -4.2 }, rotationY: 0 },
];